import { render } from "./AddProducts.vue?vue&type=template&id=effa1040"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"

import "./AddProducts.vue?vue&type=style&index=0&id=effa1040&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__